/* eslint prefer-const: 0  global-require: 0, import/no-dynamic-require: 0 */

const merge = require('deepmerge');

const AllMarkets = ['en-AU', 'en-US', 'fr-CA', 'en-CA', 'en-GB',
  'fr-FR', 'de-DE', 'nl-NL', 'fr-CH', 'de-CH', 'en-NZ',
  'sv-SE', 'fr-BE', 'nl-BE'];

const getMarkets = (locales) => {
  if (!locales) {
    return AllMarkets;
  }
  let locArr;
  if (!Array.isArray(locales)) {
    locArr = locales.split(',').map((p) => p.trim());
  } else {
    locArr = locales;
  }
  const resultArr = [];
  locArr.forEach((m) => {
    if (AllMarkets.includes(m)) {
      resultArr.push(m);
    }
  });
  return resultArr;
};

const isValid = (markets) => Array.isArray(markets) && markets.length > 0;

const getLocales = (locales) => {
  const markets = getMarkets(locales);
  if (!isValid(markets)) {
    return null;
  }
  const globalLocale = require('./global/global.locale');
  let locs = {};
  markets.forEach((mkt) => {
    locs[mkt] = merge(globalLocale, require(`./${mkt}/${mkt}.locale`));
  });
  return locs;
};

const getRules = (locales) => {
  const markets = getMarkets(locales);
  if (!isValid(markets)) {
    return null;
  }
  const globalRules = require('./global/global.rules');
  let rules = {};
  markets.forEach((mkt) => {
    rules[mkt] = merge(globalRules, require(`./${mkt}/${mkt}.rules`));
  });
  return rules;
};

const getStates = (locales) => {
  const markets = getMarkets(locales);
  if (!isValid(markets)) {
    return null;
  }
  let states = {};
  markets.forEach((mkt) => {
    states[mkt] = require(`./${mkt}/${mkt}.states`);
  });
  return states;
};

const getStatesV2 = (locales) => {
  const markets = getMarkets(locales);
  if (!isValid(markets)) {
    return null;
  }
  let states = {};
  markets.forEach((mkt) => {
    states[mkt] = require(`./${mkt}/${mkt}.v2.states`);
  });
  return states;
};

const getStates2 = (locales) => {
  const markets = getMarkets(locales);
  if (!isValid(markets)) {
    return null;
  }
  let states = {};
  markets.forEach((mkt) => {
    let list = require(`./${mkt}/${mkt}.states`);
    if (mkt === 'en-AU') {
      list = list.filter((s) => s.value.indexOf('AU:') >= 0);
      list = list.map((s) => ({ ...s, value: s.value.replace('AU: ', '') }));
    } else if (mkt === 'en-NZ') {
      list = list.filter((s) => s.value.indexOf('NZ:') >= 0);
      list = list.map((s) => ({ ...s, value: s.value.replace('NZ: ', '') }));
    }
    states[mkt] = list.map((i) => {
      const item = { ...i };
      delete item.countryId;
      return item;
    });
  });
  return states;
};

module.exports = {
  AllMarkets,
  getLocales,
  getRules,
  getStates,
  getStates2,
  getStatesV2,
};
